import { reportChartLegend } from '../../utils/reportChartLegend';
import React from 'react';
import { Form, FormGroup, FormControl, Button, Overlay, Tooltip } from 'react-bootstrap';
import config from '../../../config';
import { Chart, registerables } from 'chart.js';
import Select from 'react-select';
import moment from 'moment';
import utils from '../../utils';
import { oeeReportService } from '../../_services/oeeReport.service';
import OeeCalculationModal from './OeeCalculationModal';
import OeeAverageModal from './OeeAverageModal';
const {
    buildMetricIndex,
    formatOeeMetric,
    isCalculatedMetric,
    metricTitle,
} = require('./oeeReportPresentation');

//Chart.register(...registerables);

class DailyOEEReport extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            target: 0,
            tableHeader: '',
            selectedMachine: [],
            selectedCategory: 99,
            machineStr: '',
            originMachines: [],
            getmonth: moment().format('YYYY-MM'),
            categories: [{ value: 99, text: 'All' }, { value: 1, text: 'Machine' }, { value: 2, text: 'Line' }, { value: 3, text: 'SMT' }],
            loadingReport: false,
            revalidatingReport: false,
            reportError: '',
            reportRetryable: true,
            calculationSelection: null,
            calculationData: null,
            calculationError: '',
            tooltipTarget: null,
            tableStyle: '<meta content="text/html; charset=UTF-8" http-equiv="Content-Type"><meta content="IE=8" http-equiv="X-UA-Compatible"><title>bcl_667529169.htm</title><meta content="BCL easyConverter SDK 5.0.08" name="generator"><style> th, td {width:auto, overflow:hidden;word-wrap:break-word;text-align: center;font-size: 10pt; border: 1px solid black; position: relative; }table{max-width:2490px;width:100%;background-color:white; border-collapse: collapse;}.left{padding:5px; text-align:left}.vertical-text{position: relative;height: 300px;width: 45px;margin-left: 0;padding-right: 10px;writing-mode: tb-rl;-webkit-transform: rotate(180deg);filter: flipv fliph;}.short{height:80px}</style>',
        };
        this.node = React.createRef();
        this.reportRequestSequence = 0;
        this.activeReportRequest = null;
        this.calculationRequestSequence = 0;
    }

    componentWillMount() {
        this.setState({
            machines: []
        });
        const requestOptions = {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' },
        };

        if (localStorage.getItem('user') != null)
            return fetch(`${config.apiUrl}/getAllMachines?active=all&company=${JSON.parse(localStorage.getItem('user')).accountId}`, requestOptions)
                .then((response) => {
                    return response.text().then(text => {
                        const data = text && JSON.parse(text);

                        return data;
                    });
                })
                .then(machine => {
                    let data = [],
                        dynamicCategories = [{ text: 'All', value: 99 }];

                    // login successful if there's a user in the response
                    if (machine) {
                        machine.forEach(item => {
                            data.push({ 'id': item.id, 'label': item.machine, 'category': item.category, 'value': item.machine });
                            if (item.description && !dynamicCategories.some(cat => cat.value === item.category)) {
                                dynamicCategories.push({ text: item.description, value: item.category });
                            }
                        })

                        this.setState({ machines: data });
                        this.setState({ originMachines: data });
                        dynamicCategories.length > 1 && this.setState({ categories: dynamicCategories });

                        const { oee } = (() => {
                            try {
                                return { oee: JSON.parse(localStorage.getItem('monthlyTargetsOEE') || '{}') };
                            } catch (e) {
                                return { oee: {} };
                            }
                        })();
                        const month = new Date().getMonth() + 1;
                        const year = new Date().getFullYear();
                        const monthTarget = (oee[String(year)] && oee[String(year)][month]) || (localStorage.getItem('target1') || '80').split(',')[0];

                        // Pre-select machine from URL query param if present
                        // App uses hash router: /#/dailyoeereport?machine=X, so parse from hash
                        const hashQuery = window.location.hash.includes('?') ? window.location.hash.split('?')[1] : '';
                        const urlParams = new URLSearchParams(hashQuery);
                        const machineName = urlParams.get('machine');
                        if (machineName) {
                            const matched = data.find(m => m.value === machineName);
                            if (matched) {
                                this.setState({ target: monthTarget, selectedMachine: [matched], selectedCategory: 99 }, () => {
                                    this.buildHtmlTable();
                                });
                                return machine;
                            }
                        }

                        // Cached reports can render immediately, so commit the target first.
                        this.setState({ target: monthTarget }, () => this.buildHtmlTable());
                    }

                    return machine;
                });
    }

    componentDidMount() {
        const node = this.node;
        var ctx = document.getElementById("dailyOEEchart");
        ctx.style.backgroundColor = 'rgba(53,53,53,255)';
        Chart.defaults.global.defaultFontColor = '#B8B3B3';
        window.dailyOEEchart = new Chart(node, {
            type: 'bar',
            data: {
                datasets: [
                    {
                        label: 'Average',
                        data: [],
                        borderColor: 'rgb(255, 99, 132)',
                        backgroundColor: 'rgba(255, 99, 132)'
                    },
                    {
                        label: 'Target',
                        data: [],
                        type: 'line',
                        fill: false,
                        borderColor: "rgb(54, 162, 235)"
                    },
                ],
                labels: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31],
            },
            options: {
                legend: {
                    labels: {
                        usePointStyle: true,
                        boxWidth: 20,
                        padding: 20,
                        generateLabels: reportChartLegend
                    }
                },
                scales: {
                    xAxes: [{
                        display: true,
                        gridLines: {
                            display: true,
                            color: "#FFFFFF3"
                        }

                    }],
                    yAxes: [{
                        display: true,
                        gridLines: {
                            display: true,
                            color: "#FFFFFF2"
                        },
                        ticks: {
                            min: 0,
                            max: 100
                        }
                    }]
                },
                title: {
                    display: true,
                    text: ['PRODUCTION DAILY OVERALL EQUIPMENT EFFICIENCY PERFORMANCE( OEE )', 'Daily Target: ' + this.state.target + '% ']

                },
                plugins: {
                    labels: false
                }
            },
        });
    }

    tdWrap(content, target, metric, selection) {
        let style = '';
        const title = metricTitle(metric);
        if (Number(content) === 0) {
            style = isCalculatedMetric(metric)
                ? ' style="color: #ff0000;"'
                : ' style="color: #000000;"';
        } else if (isCalculatedMetric(metric) && Number.isFinite(Number(target))) {
            style = Number(metric.oee) >= Number(target)
                ? ' style="color: #28a745;"'
                : ' style="color: #ff0000;"';
        }
        const titleAttribute = title ? ' title="' + title + '"' : '';
        const detailAttributes = selection && selection.kind === 'average'
            ? ' class="oee-calculation-cell" role="button" tabindex="0" data-oee-average="'
                + encodeURIComponent(JSON.stringify(Object.assign({}, selection, { displayedOee: metric && metric.oee }))) + '"'
            : selection ? ' class="oee-calculation-cell" role="button" tabindex="0" data-oee-machine="'
            + encodeURIComponent(selection.machine) + '" data-oee-date="' + selection.date
            + '" data-oee-value="' + (metric && metric.oee != null ? Number(metric.oee) : '') + '"' : '';
        const aboveMaximum = isCalculatedMetric(metric) && Number(metric.oee) > 100;
        if (aboveMaximum) {
            style = ' style="background-color: #ffc0c0; color= #000000;"';
        }
        const warning = metric && (metric.performanceExceeds100 || metric.performance > 100)
            ? 'Performance exceeds 100%. Possible cause: Ideal cycle time longer than actual. Also check repeated submissions, recorded output and downtime.'
            : 'OEE exceeds 100%. Open the calculation to check cycle times, recorded output, downtime and scheduled time.';
        const tooltipText = aboveMaximum ? warning : content === 'N/A' ? title : '';
        const warningAttributes = tooltipText ? ' data-oee-warning="' + tooltipText + '"' : '';
        const icon = aboveMaximum ? ' <span aria-hidden="true" style="display:inline-block;color:#b02a37;font-weight:bold;">&#8252;</span>' : '';
        return '<td' + style + (tooltipText ? '' : titleAttribute) + detailAttributes + warningAttributes + '>' + content + icon + '</td>';
    }

    showOeeTooltip = event => {
        const cell = event.target.closest('[data-oee-warning]');
        if (!cell || this.state.tooltipTarget === cell) return;
        if (this.state.tooltipTarget) this.state.tooltipTarget.removeAttribute('aria-describedby');
        cell.setAttribute('aria-describedby', 'oee-warning-tooltip');
        this.setState({ tooltipTarget: cell });
    };

    hideOeeTooltip = event => {
        const cell = this.state.tooltipTarget;
        if (event && cell && event.relatedTarget && cell.contains(event.relatedTarget)) return;
        if (cell) cell.removeAttribute('aria-describedby');
        this.setState({ tooltipTarget: null });
    };

    openCalculation = (selection) => {
        this.hideOeeTooltip();
        const sequence = ++this.calculationRequestSequence;
        const request = selection.kind === 'average' ? oeeReportService.getAverageExplanation(selection) : oeeReportService.getExplanation(selection);
        this.setState({ calculationSelection: selection, calculationKind: selection.kind, calculationData: request.data,
            calculationLoading: !request.data, calculationRefreshing: Boolean(request.data), calculationError: '' });
        return request.revalidate.then(data => {
            if (sequence === this.calculationRequestSequence) this.setState({ calculationData: data,
                calculationLoading: false, calculationRefreshing: false });
        }).catch(error => {
            if (sequence === this.calculationRequestSequence) this.setState({ calculationError: error.message || 'Unable to load calculation.',
                calculationLoading: false, calculationRefreshing: false });
        });
    };

    closeCalculation = () => {
        this.calculationRequestSequence += 1;
        this.setState({ calculationSelection: null });
    };

    handleCalculationClick = event => {
        if (event.type === 'keydown' && event.key === 'Escape') {
            this.hideOeeTooltip();
            return;
        }
        if (event.type === 'keydown' && !['Enter', ' '].includes(event.key)) return;
        const cell = event.target.closest('[data-oee-date], [data-oee-average]');
        if (!cell) return;
        event.preventDefault();
        if (cell.dataset.oeeAverage) {
            this.openCalculation(JSON.parse(decodeURIComponent(cell.dataset.oeeAverage)));
            return;
        }
        this.openCalculation({ machine: decodeURIComponent(cell.dataset.oeeMachine), date: cell.dataset.oeeDate,
            displayedOee: cell.dataset.oeeValue === '' ? null : Number(cell.dataset.oeeValue) });
    };

    componentWillUnmount() {
        this.calculationRequestSequence += 1;
        this.activeReportRequest = null;
    }

    buildHtmlTable() {
        const reportMonth = this.state.getmonth;
        const reportCategory = this.state.selectedCategory;
        const reportMachines = this.state.selectedMachine;
        const requestIdentity = {
            id: ++this.reportRequestSequence,
            key: JSON.stringify([reportMonth, reportCategory, reportMachines]),
        };
        this.activeReportRequest = requestIdentity;
        const isActiveRequest = () => Boolean(this.activeReportRequest)
            && this.activeReportRequest.id === requestIdentity.id
            && this.activeReportRequest.key === requestIdentity.key;
        const request = oeeReportService.getDaily({
            month: reportMonth,
            category: reportCategory,
            machines: reportMachines,
        });
        if (request.data) {
            this.applyDailyReport(request.data, reportMonth);
        }
        this.setState({
            loadingReport: !request.data,
            revalidatingReport: Boolean(request.data),
            reportError: '',
            reportRetryable: true,
        });
        return request.revalidate
            .then((report) => {
                if (!isActiveRequest()) return report;
                this.applyDailyReport(report, reportMonth);
                this.setState({
                    loadingReport: false,
                    revalidatingReport: false,
                    reportError: '',
                    reportRetryable: true,
                });
                return report;
            })
            .catch((error) => {
                if (!isActiveRequest()) return null;
                const retryable = !error || error.retryable !== false;
                this.setState({
                    loadingReport: false,
                    revalidatingReport: false,
                    reportError: retryable
                        ? 'OEE report unavailable. Retry.'
                        : (error.message || 'OEE report unavailable.'),
                    reportRetryable: retryable,
                });
                return null;
            });
    }

    applyDailyReport(report, reportMonth = this.state.getmonth) {
        const { tableStyle } = this.state;
        const year = reportMonth.substring(0, 4);
        const month = reportMonth.substring(5, 7);
        const daysInMonth = new Date(year, month, 0).getDate();
        const cellIndex = buildMetricIndex(
            report.cells,
            cell => cell.machine + '|' + cell.period
        );
        const machineSummaryIndex = buildMetricIndex(
            report.machineSummaries,
            summary => summary.machine
        );
        const periodSummaryIndex = buildMetricIndex(
            report.periodSummaries,
            summary => summary.period
        );
        const periods = Array.from({ length: daysInMonth }, (_unused, index) => (
            reportMonth + '-' + String(index + 1).padStart(2, '0')
        ));
        const chartLabels = periods.map((_period, index) => index + 1);
        const target = this.state.target;
        const chartTarget = Number(target);
        const targetValue = Number.isFinite(chartTarget) ? chartTarget : target;
        const averageSelection = { kind: 'average', month: reportMonth,
            machines: (report.machineSummaries || []).map(summary => summary.machine) };

        let header = '<table id="dailyoeereport" class="highlight-table" border=1; cellspacing=0/>'
            + '<tr>'
            + '<th style = "">Date</th>';
        periods.forEach((_period, index) => {
            header += '<th style = "">' + (index + 1) + '</th>';
        });
        header += '<th style = "">MTD Average</th></tr>';

        let html = '';
        (report.machineSummaries || []).forEach(machineSummary => {
            html += '<tr>';
            html += this.tdWrap(machineSummary.machine);
            periods.forEach(period => {
                const metric = cellIndex.get(machineSummary.machine + '|' + period);
                html += this.tdWrap(formatOeeMetric(metric), target, metric, { machine: machineSummary.machine, date: period });
            });
            const suppliedSummary = machineSummaryIndex.get(machineSummary.machine);
            html += this.tdWrap(formatOeeMetric(suppliedSummary), target, suppliedSummary,
                Object.assign({}, averageSelection, { scope: 'machine', machines: [machineSummary.machine] }));
            html += '</tr>';
        });

        html += '<tr>';
        html += this.tdWrap('Average');
        const chartValues = periods.map(period => {
            const metric = periodSummaryIndex.get(period);
            html += this.tdWrap(formatOeeMetric(metric), target, metric,
                Object.assign({}, averageSelection, { scope: 'day', date: period }));
            return isCalculatedMetric(metric) ? Number(metric.oee) : null;
        });
        html += this.tdWrap(
            formatOeeMetric(report.overallSummary),
            target,
            report.overallSummary,
            Object.assign({}, averageSelection, { scope: 'overall' })
        );
        html += '</tr>';

        html += '<tr>';
        html += this.tdWrap('Target');
        periods.forEach(() => {
            html += this.tdWrap(target);
        });
        html += this.tdWrap(target + '%');
        html += '</tr>';

        const safeHTML = utils.sanitizeVoidTags((tableStyle + header + html)
            .replaceAll('</img>', '')
            .replaceAll('</input>', '')
            .replaceAll('</br>', '<br/>')
            .replaceAll('</hr>', '<hr/>'));

        this.hideOeeTooltip();
        this.setState({ table: safeHTML });
        this.drawChart(chartValues, periods.map(() => targetValue), chartLabels);
        return report;
    }
    exportExcel() {
        utils.tableToExcel('datatable', 'Report', 'DailyOEEReport_' + this.state.month + '.xls');
    };

    drawChart(d, m, labels) {
        const backgroundColors = d.map((val, index) => (val >= m[index] ? 'rgba(40, 167, 69, 0.8)' : 'rgba(255, 99, 132, 0.8)'));
        const borderColors = d.map((val, index) => (val >= m[index] ? 'rgb(40, 167, 69)' : 'rgb(255, 99, 132)'));
        window.dailyOEEchart.data.datasets[0].backgroundColor = backgroundColors;
        window.dailyOEEchart.data.datasets[0].borderColor = borderColors;
        window.dailyOEEchart.data.datasets[0].data = d;
        window.dailyOEEchart.data.datasets[1].data = m;
        window.dailyOEEchart.data.labels = labels;
        window.dailyOEEchart.options.title.text = ['PRODUCTION DAILY OVERALL EQUIPMENT EFFICIENCY PERFORMANCE( OEE )', 'Daily Target: ' + this.state.target + '% '];
        window.dailyOEEchart.update();
    }

    optionClicked(optionsList) {
        this.setState({ machines: optionsList });
    }
    selectedBadgeClicked(optionsList) {
        this.setState({ selectedMachine: optionsList }, () => this.buildHtmlTable());
    }

    selectCategory(selectedCategory) {
        const machines = selectedCategory === 99
            ? this.state.originMachines
            : this.state.originMachines.filter(machine => (
                Number(machine.category) === selectedCategory
            ));
        const allowedMachines = new Set(machines.map(machine => machine.value));
        const selectedMachine = selectedCategory === 99
            ? []
            : (this.state.selectedMachine || []).filter(machine => {
                const machineName = typeof machine === 'string'
                    ? machine
                    : machine && (machine.value || machine.label);
                return allowedMachines.has(machineName);
            });
        this.setState({
            machines,
            selectedCategory,
            selectedMachine,
        }, () => this.buildHtmlTable());
    }


    render() {
        return (
            <div style={{ width: '100%' }}>
                <div className="container" style={{ marginBbottom: '20em', position: 'relative', minHeight: '50px' }}>
                    <Form inline>
                        <FormGroup controlId="formInlineEmail">
                            <Form.Label>Month,Year</Form.Label>{' '}
                            <FormControl type="month"
                                className="daily-report-month-picker"
                                value={this.state.getmonth}
                                onChange={(e) => this.setState(
                                    { getmonth: e.target.value },
                                    () => this.buildHtmlTable()
                                )}
                            />
                        </FormGroup>{' '}
                        <FormGroup controlId="formInlineName">
                            <Form.Label> Category:</Form.Label>{' '}
                                <FormControl as="select" placeholder="select"
                                    value={this.state.selectedCategory} onChange={(e) => {
                                        const selectedCategory = Number(e.target.value);
                                        this.selectCategory(selectedCategory);
                                    }}>
                                <option value="0">select</option>
                                {
                                    this.state.categories.map((category) => {
                                        return <option key={category.value} value={category.value}>{category.text}</option>
                                    })
                                }
                            </FormControl>
                        </FormGroup>{'   '}
                        {this.state.selectedCategory != 99 && <FormGroup controlId="formInlineName">
                            <div class="col-xs-2" style={{ marginTop: '10px' }}>
                                <Form.Label> Items:</Form.Label></div>{' '}
                            <div class="col-xs-10" style={{ minWidth: '200px' }}>
                                <Select
                                    options={this.state.machines}
                                    value={this.state.selectedMachine}
                                    isMulti
                                    onChange={this.selectedBadgeClicked.bind(this)}
                                    className="basic-multi-select"
                                    classNamePrefix="select"
                                />
                            </div>
                        </FormGroup>}{' '}
                        <Button
                            bsStyle="primary"
                            style={{ float: "right", margin: 10 }}
                            onClick={(e) => {
                                e.preventDefault();
                                this.buildHtmlTable();
                            }}>Show</Button>
                    </Form>
                    {this.state.loadingReport ? <div>Loading OEE report…</div> : null}
                    {this.state.revalidatingReport ? <div>Refreshing OEE report…</div> : null}
                    {this.state.reportError ? <div role="alert">
                        {this.state.reportError}{' '}
                        {this.state.reportRetryable ? <Button
                            bsStyle="primary"
                            onClick={() => this.buildHtmlTable()}>Retry</Button> : null}
                    </div> : null}
                    <canvas id="dailyOEEchart" width="600" height="200" ref={node => (this.node = node)} style={{ marginTop: '10px' }}></canvas>
                    {this.state.table ? <div style={{ width: "100%" }}><Button
                        bsStyle="primary"
                        style={{ float: "right", margin: 10 }}
                        onClick={e => this.exportExcel()}>Export</Button></div> : ''}
                    <a id='dlink' style={{ display: 'none' }}></a>
                </div>
                <style>{'.oee-calculation-cell { cursor: pointer; } .oee-calculation-cell:hover, .oee-calculation-cell:focus-visible { background: #e8f0fe; outline: 2px solid #4285d4; outline-offset: -2px; }'}</style>
                <div id="datatable" className="report-sticky-header"
                    style={{ boxSizing: 'border-box', padding: '0 12px', width: '100%' }} onClick={this.handleCalculationClick}
                    onMouseOver={this.showOeeTooltip} onMouseOut={this.hideOeeTooltip}
                    onFocus={this.showOeeTooltip} onBlur={this.hideOeeTooltip}
                    onKeyDown={this.handleCalculationClick} dangerouslySetInnerHTML={{ __html: this.state.table }} />
                <Overlay target={this.state.tooltipTarget} show={Boolean(this.state.tooltipTarget)} placement="top">
                    {props => <Tooltip {...props} id="oee-warning-tooltip" style={{ ...props.style, pointerEvents: 'none' }}>
                        {this.state.tooltipTarget && this.state.tooltipTarget.dataset.oeeWarning}
                    </Tooltip>}
                </Overlay>
                {this.state.calculationKind === 'average' ? <OeeAverageModal selection={this.state.calculationSelection} data={this.state.calculationData}
                    loading={this.state.calculationLoading} refreshing={this.state.calculationRefreshing}
                    error={this.state.calculationError} onClose={this.closeCalculation}
                    onRetry={() => this.openCalculation(this.state.calculationSelection)} />
                : <OeeCalculationModal selection={this.state.calculationSelection} data={this.state.calculationData}
                    loading={this.state.calculationLoading} refreshing={this.state.calculationRefreshing}
                    error={this.state.calculationError} onClose={this.closeCalculation}
                    onRetry={() => this.openCalculation(this.state.calculationSelection)} />}
            </div>
        );
    }
}

export { DailyOEEReport };
